import PropTypes from 'prop-types'
import { H4, Caption } from '../../../cdl-react-components/components'
import Link from '../../../Utilities/Link'
import { formatResultsItemDate } from '../../../../utilities'

const regionalMapItem = (props) => {    
    const { regionalMap } = props
    return (
        <Link
            href={'/map/' + regionalMap.id}
            onClick={props.handleResultSelect}
            className={'results__item' + (new Date(regionalMap.publication_date) > Date.now() ? ' unpublished': '')}
            title={regionalMap.title}>
            <H4>{regionalMap.title}</H4>
            <Caption>CDL Map Series | {formatResultsItemDate(regionalMap)}</Caption>
        </Link>
    )
}

regionalMapItem.propTypes = {
    regionalMap: PropTypes.object.isRequired,
    handleResultSelect: PropTypes.func.isRequired
}

export default regionalMapItem